import React from 'react';
import BottomNav from '../components/BottomNav';

const PreviewBottomNav = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF9] flex flex-col justify-end">
      <div className="max-w-md mx-auto p-6 text-center text-stone-700">Bottom navigation preview — active = home</div>
      <BottomNav currentPage="home" />
    </div>
  );
};

export default PreviewBottomNav;
